<template>
  <div class="metal_changed_pic">
    <img :src="imageUrl" />
    <div class="metal-text">
      <div class="commemorativeLicensePlateImageText">
        <div class="textContainer">
          <span class="text" v-html="textInfo[0].textContent"></span>
        </div>
      </div>
      <div class="commemorativeLicensePlateNumber">
        <div class="textContainer">
          <span class="text" v-html="textInfo[1].textContent"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/commonMixin.js";
export default {
  name: "CustomizeMetalAV",
  mixins: [commonMixin],
  mounted() {
    this.calcEmFontsizeBase();
    this.controlWrapNotReverse(
      0,
      this.customTextCommemorativeLicensePlateImageText
    );
    this.controlFontsize(0, this.customTextCommemorativeLicensePlateImageText);
    this.controlWrapNotReverse(
      1,
      this.customTextCommemorativeLicensePlateNumber
    );
    this.controlFontsize(1, this.customTextCommemorativeLicensePlateNumber);
  },
  data() {
    return {
      textInfo: [
        {
          name: "commemorativeLicensePlateImageText",
          lineLimit:
            this.$store.getters.textSettingByComponentCode("AV")
              .commemorativeLicensePlateImageText.lineLimit,
          textLimit:
            this.$store.getters.textSettingByComponentCode("AV")
              .commemorativeLicensePlateImageText.textLimit,
          maxFontsize:
            this.$store.getters.textSettingByComponentCode("AV")
              .commemorativeLicensePlateImageText.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
        {
          name: "commemorativeLicensePlateNumber",
          lineLimit:
            this.$store.getters.textSettingByComponentCode("AV")
              .commemorativeLicensePlateNumber.lineLimit,
          textLimit:
            this.$store.getters.textSettingByComponentCode("AV")
              .commemorativeLicensePlateNumber.textLimit,
          maxFontsize:
            this.$store.getters.textSettingByComponentCode("AV")
              .commemorativeLicensePlateNumber.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
      ],
    };
  },
  watch: {
    customTextCommemorativeLicensePlateImageText() {
      this.controlWrapNotReverse(
        0,
        this.customTextCommemorativeLicensePlateImageText
      );
      this.controlFontsize(
        0,
        this.customTextCommemorativeLicensePlateImageText
      );
    },
    customTextCommemorativeLicensePlateNumber() {
      this.controlWrapNotReverse(
        1,
        this.customTextCommemorativeLicensePlateNumber
      );
      this.controlFontsize(1, this.customTextCommemorativeLicensePlateNumber);
    },
  },
  computed: {
    imageUrl() {
      const metalData =
        this.$store.getters.customizeMetalDataByComponentCode("AV");
      return metalData.imagePath;
    },
    //得到使用者動態輸入的值
    customTextCommemorativeLicensePlateImageText() {
      return this.$store.getters.currentCustom.engraving_content.content
        .commemorativeLicensePlateImageText;
    },
    customTextCommemorativeLicensePlateNumber() {
      return this.$store.getters.currentCustom.engraving_content.content
        .commemorativeLicensePlateNumber;
    },
  },
};
</script>

<style scoped lang="scss">
.metal_changed_pic {
  position: relative;
  font-family: "Noto Serif TC";
  img {
    width: 100%;
  }
  .metal-text {
    position: absolute;
    top: 100px;
    left: 57px;
    color: $primaryLightColor;
    font-weight: 800;
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 62px;
      left: 5.6px;
    }
    @include table {
      transform: scale(0.7);
      top: 41px;
      left: -19px;
    }
    @include phone {
      transform: scale(0.64);
      top: 28px;
      left: -33px;
    }
  }
}
.commemorativeLicensePlateImageText {
  height: 70px;
  width: 127px;
  border: 1px dashed $primaryLightColor;
  margin: 0 auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 127px;
    span {
      white-space: nowrap;
    }
  }
}
.commemorativeLicensePlateNumber {
  width: 387px;
  height: 125px;
  margin: 0 auto;
  border: 1px dashed $primaryLightColor;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 387px;
    span {
      white-space: nowrap;
    }
  }
}
</style>
